export function areRoutesEqual(a, b) {
    if (a.paths.join(' ') !== b.paths.join(' ')) {
        return false;
    }
    if (typeof a.search === 'object' && typeof b.search === 'object') {
        const aString = Object.entries(a.search).join(' ');
        const bString = Object.entries(b.search).join(' ');
        if (aString !== bString) {
            return false;
        }
    }
    else if (a.search !== b.search) {
        return false;
    }
    return a.hash === b.hash;
}
